import React from 'react';
import { handleError } from '../../../utils/helpers';

var Error = function Error(_ref) {
  var title = _ref.title,
      description = _ref.description,
      closeToast = _ref.closeToast;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "h-6 w-6 text-red-400",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 w-0 flex-1 pt-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-5 font-medium text-gray-900"
  }, title || 'Error'), /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-sm leading-5 text-gray-600"
  }, handleError(description))), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 flex-shrink-0 flex"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: closeToast,
    className: "inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150 hover:text-gray-600"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "h-5 w-5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })))));
};

export default Error;